/* KODO product page (sections/kodo-pdp.liquid): purchase toggle, the cart (as on the live
   product page, kodo-product-day.js), first-order code, sticky bar, pair card, gallery,
   timeline reveal and the molecule drawings. One init per section instance. */
(function () {
function init(root) {
  if (!root || root.dataset.rvReady) return;
  root.dataset.rvReady = '1';
  var q = function (s, el) { return (el || root).querySelector(s); };
  var qa = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var unit = root.dataset.unit || 'day';

  /* First-order code (as on V17): the offer belongs to visitors who left their email in the
     welcome popup (kodo-welcome-popup writes "done" to localStorage, or Shopify sends them
     back with ?customer_posted=true). For them One-time shows the code's figure with the full
     price struck through, and the pill shows while One-time is chosen; the code is one-time
     only, so it hides for Subscribe. */
  var welcomeClaimed = /[?&]customer_posted=true/.test(location.search);
  try { if (localStorage.getItem('kodoWelcome') === 'done') welcomeClaimed = true; } catch (err) {}
  var welcomePrice = welcomeClaimed ? root.dataset.welcomePrice : '';
  var welcomeDay = root.dataset.welcomeDay || '';
  var codePill = q('[data-rv-code]');

  /* One-time / Subscribe: the hidden selling_plan input and the figures. */
  var seg = q('.rv-seg'), plan = q('[data-rv-plan]');
  var sbk = q('[data-rv-sbk]'), sbp = q('[data-rv-sbp]'), sbsel = q('[data-rv-sbsel]');
  var picked = 'one';
  /* The pair card ticked: both packs carry the bundle cut (Paul, 14 Oct), so this pack's own
     figures switch to the bund_* ones the section puts on the segment control. */
  function pairTicked() { var b = q('[data-rv-pair]'); return !!b && b.getAttribute('aria-checked') === 'true'; }
  function pick(k) {
    if (!seg) return;
    picked = k;
    var sub = k === 'sub', d = seg.dataset, bund = pairTicked() && d.bundOncePrice;
    var price = bund ? (sub ? d.bundSubPrice : d.bundOncePrice) : (sub ? d.subPrice : d.oncePrice);
    var day = bund ? (sub ? d.bundSubDay : d.bundOnceDay) : (sub ? d.subDay : d.onceDay);
    qa('[data-rv-opt]', seg).forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.rvOpt === k)); });
    if (plan) plan.disabled = !sub;
    q('[data-rv-price]').textContent = price;
    var was = q('[data-rv-was]'), tag = q('[data-rv-savetag]');
    if (was) { was.hidden = !(sub || bund); was.textContent = d.oncePrice; }
    if (tag) tag.hidden = !sub;
    var dl = q('[data-rv-deliv]'); if (dl) dl.textContent = sub ? dl.dataset.sub : dl.dataset.once;
    q('[data-rv-perday]').textContent = day + ' a ' + unit;
    if (sbk) sbk.textContent = sub ? 'Subscription' : 'One-time purchase';
    if (sbp) sbp.textContent = price + ' (' + day + ' a ' + unit + ')';
    if (sbsel) sbsel.value = k;
    var pp = q('[data-rv-pairp]'), pc = q('[data-rv-pair]');
    if (pp && pc) pp.textContent = sub ? pc.dataset.addonSub : pc.dataset.addonOne;
    if (codePill) codePill.hidden = !(welcomePrice && !sub && !bund);
    if (welcomePrice && !sub && !bund) {
      q('[data-rv-price]').textContent = welcomePrice;
      if (was) { was.hidden = false; was.textContent = d.oncePrice; }
      q('[data-rv-perday]').textContent = (welcomeDay || d.onceDay) + ' a ' + unit;
      if (sbp) sbp.textContent = welcomePrice + ' (' + (welcomeDay || d.onceDay) + ' a ' + unit + ')';
    }
  }
  if (seg) {
    qa('[data-rv-opt]', seg).forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.rvOpt); }); });
    if (sbsel) sbsel.addEventListener('change', function () { pick(sbsel.value); });
    if (welcomePrice) pick('one');
  }

  /* Put the code on the cart, once a browser session, for a visitor who claimed it.
     Shopify's /discount/CODE route stores it for checkout and applies it to the cart. */
  var welcomeCode = welcomeClaimed ? root.dataset.welcomeCode : '';
  if (welcomeCode) {
    var applied = false;
    try { applied = sessionStorage.getItem('kodoWelcomeApplied') === welcomeCode; } catch (err) {}
    if (!applied) {
      var shopRootW = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(shopRootW + 'discount/' + encodeURIComponent(welcomeCode), { credentials: 'same-origin' })
        .then(function () { try { sessionStorage.setItem('kodoWelcomeApplied', welcomeCode); } catch (err) {} })
        .catch(function () {});
    }
  }

  /* One pack per click (no quantity stepper on this page, Paul 7 Oct); the drawer changes quantity. */
  var qty = 1;

  /* Sticky bar: on from the first paint (Revamp V2, Paul 14 Oct), not only once the real button has
     scrolled away. Its Add button presses the real one. */
  var buy = q('[data-rv-buy]'), bar = q('[data-rv-sticky]');
  if (buy && bar) {
    bar.classList.add('on'); bar.setAttribute('aria-hidden', 'false');
    var add = q('[data-rv-sbadd]'); if (add) add.addEventListener('click', function () { buy.click(); });
  }

  /* The cart, as on the live product page (kodo-product-day.js):
     - the click opens the drawer straight away, so it is on screen while the add is in flight;
     - the submit is taken over: one /cart/add.js request with the quantity, the selling plan
       when Subscribe is chosen and the drawer's markup, then the theme's cart:update, which
       re-renders the drawer and the header count. Horizon's own handler stays out of it.
     Pair card ticked: the buttons read "Add both to cart" and the same request carries both
     packs, each on its monthly plan when Subscribe is chosen. */
  var pairBtn = q('[data-rv-pair]');
  var pairOn = function () { return !!pairBtn && pairBtn.getAttribute('aria-checked') === 'true'; };
  var relabel = function () { var on = pairOn(); qa('[data-rv-buy], [data-rv-sbadd]').forEach(function (b) { b.textContent = on ? 'Add both to cart' : 'Add to cart'; }); };
  var openDrawer = function () { var d = document.querySelector('cart-drawer-component'); if (d && typeof d.open === 'function') d.open(); };
  /* While the add is in flight (0.6 to 0.8 s on this store, 13 Oct 2026) the drawer would show
     whatever it held at page load, an empty cart more often than not, and then jump to the item.
     The class below swaps that for an "Adding to your cart" line (assets/kodo-pdp.css) until the
     cart:update lands or the add fails. */
  /* The drawer fills in at once (Paul, 14 Oct: no waiting line): a stand-in row for this pack, and one
     for the other pack when the pair is ticked, drawn from what the page already knows (title, variant
     photo, the price on screen). The server's own rows replace them when cart:update lands. */
  var ghostRow = function (img, title, line, price) {
    var el = document.createElement('div'); el.className = 'rv-ghost';
    el.innerHTML = '<div class="rv-ghost__media">' + (img ? '<img src="' + img + '" alt="" width="64" height="64">' : '') + '</div>' +
      '<div class="rv-ghost__body"><p class="rv-ghost__title"></p><p class="rv-ghost__line"></p><p class="rv-ghost__qty">1</p></div>' +
      '<p class="rv-ghost__price"></p>';
    el.querySelector('.rv-ghost__title').textContent = title || '';
    el.querySelector('.rv-ghost__line').textContent = line || '';
    el.querySelector('.rv-ghost__price').textContent = price || '';
    return el;
  };
  var adding = function (on) {
    var d = document.querySelector('cart-drawer-component'); if (!d) return;
    d.classList.toggle('rv-adding', !!on);
    qa('.rv-ghost', d).forEach(function (g) { g.remove(); });
    if (!on) return;
    var host = d.querySelector('.cart-drawer__items') || d.querySelector('.cart-drawer__content'); if (!host) return;
    var sub = plan && !plan.disabled && plan.value;
    var line = sub ? ((q('[data-rv-deliv]') || {}).dataset || {}).sub || 'Subscription' : 'One-time purchase';
    var wrap = document.createElement('div'); wrap.className = 'rv-ghosts';
    var atc = q('add-to-cart-component');
    wrap.appendChild(ghostRow(atc && atc.dataset.productVariantMedia, (q('.rv-h1') || {}).textContent, line, (q('[data-rv-price]') || {}).textContent));
    var pc = q('[data-rv-pair]');
    if (pc && pc.getAttribute('aria-checked') === 'true') {
      var pimg = q('.rv-pr-th'), ptitle = (q('.rv-pr-tx b') || {}).textContent || '', plabel = ((q('.rv-pr-tx b') || {}).dataset || {}).label;
      ptitle = ptitle.replace(/^\s*pair with\s*/i, '');
      var pprice = ((q('[data-rv-pairp]') || {}).textContent || '').replace(/^\+/, '');
      wrap.appendChild(ghostRow(pimg && pimg.tagName === 'IMG' ? pimg.getAttribute('src') : '', ptitle, line, pprice));
    }
    host.insertBefore(wrap, host.firstChild);
  };
  if (pairBtn) {
    var togglePair = function () { pairBtn.setAttribute('aria-checked', String(!pairOn())); relabel(); pick(picked); };
    /* the thumbnail is a link to the other pack's page; everything else toggles the tick */
    pairBtn.addEventListener('click', function (e) { if (e.target.closest('[data-rv-pair-link]')) return; togglePair(); });
    pairBtn.addEventListener('keydown', function (e) { if (e.target !== pairBtn) return; if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); togglePair(); } });
  }
  var form = buy && buy.closest('form');
  if (buy) buy.addEventListener('click', function () { if (!buy.disabled) { adding(true); openDrawer(); } });
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // keep the theme handler out of it
      var sub = plan && !plan.disabled && plan.value;
      var idInput = form.querySelector('[name="id"]');
      var main = { id: Number(idInput && idInput.value), quantity: qty };
      if (sub) main.selling_plan = Number(plan.value);
      var items = [main];
      if (pairOn()) {
        var mate = { id: Number(pairBtn.dataset.pairVariant), quantity: qty };
        if (sub && pairBtn.dataset.pairPlan) mate.selling_plan = Number(pairBtn.dataset.pairPlan);
        items.push(mate);
      }
      var body = items.length === 1 ? main : { items: items };
      var ci = document.querySelector('cart-items-component'); if (ci && ci.dataset.sectionId) body.sections = ci.dataset.sectionId;
      var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      buy.disabled = true;
      fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (added) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: added, sourceId: 'kodo-pdp', data: {
            source: 'product-form-component', productId: root.dataset.productId,
            itemCount: (added && added.quantity) || qty * items.length, sections: added && added.sections } } }));
        })
        .catch(function () { /* the cart is unchanged, and nothing has claimed otherwise */ })
        .then(function () { adding(false); buy.disabled = false; relabel(); });
    }, true);
  }
  /* Same as V17: the drawer opens when this product's add lands, in case the click did not open it. */
  document.addEventListener('cart:update', function (e) {
    adding(false);
    var data = (e.detail && e.detail.data) || {};
    if (data.source !== 'product-form-component' || data.didError) return;
    if (String(data.productId) !== String(root.dataset.productId)) return;
    openDrawer();
  });

  /* Pinned gallery: sits 16px under whatever is stuck to the top of the window (the announcement
     bar and the header), so on load it is already where it stays. */
  var stickTop = function () {
    var bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
      var cs = getComputedStyle(el); if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var t = parseFloat(cs.top) || 0; bottom = Math.max(bottom, t + el.offsetHeight);
    });
    root.style.setProperty('--rv-stick-top', (bottom + 16) + 'px');
  };
  stickTop(); window.addEventListener('resize', stickTop); window.addEventListener('load', stickTop);

  /* Gallery tiles that hold a designed card (the label) rather than a photo: the four corners share
     one colour, so the tile takes that colour and the image sits whole inside it (Paul, 14 Oct: the
     label was cropped on a phone). Photos keep the cover crop. */
  qa('.rv-gal .rv-tile img').forEach(function (img) {
    function check() {
      try {
        var c = document.createElement('canvas'), w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return;
        c.width = 8; c.height = 8;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h, 0, 0, 8, 8);
        var d = x.getImageData(0, 0, 8, 8).data;
        var px = function (i, j) { var o = (j * 8 + i) * 4; return [d[o], d[o + 1], d[o + 2]]; };
        /* the four corners and the middle of each edge: a card keeps its frame colour all the way round,
           a photo on a plain ground does not (the hand runs off the bottom edge) */
        var corners = [px(0, 0), px(7, 0), px(0, 7), px(7, 7), px(4, 0), px(4, 7), px(0, 4), px(7, 4)], a = corners[0];
        var same = corners.every(function (p) { return Math.abs(p[0] - a[0]) + Math.abs(p[1] - a[1]) + Math.abs(p[2] - a[2]) < 24; });
        if (!same) return;
        var tile = img.closest('.rv-tile'); if (!tile) return;
        tile.classList.add('rv-tile--card');
        tile.style.background = 'rgb(' + a.join(',') + ')';
      } catch (err) { /* a cross-origin canvas: leave the crop as it is */ }
    }
    img.crossOrigin = 'anonymous';
    if (img.complete && img.naturalWidth) check(); else img.addEventListener('load', check);
  });

  /* Gallery dots on a phone (the desktop shows the grid). */
  var gal = q('[data-rv-gal]'), dots = q('[data-rv-dots]');
  if (gal && dots) {
    var tiles = qa('.rv-tile', gal);
    dots.innerHTML = tiles.map(function (_, i) { return '<i' + (i === 0 ? ' class="on"' : '') + '></i>'; }).join('');
    var ds = qa('i', dots);
    gal.addEventListener('scroll', function () { var k = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)); ds.forEach(function (d, j) { d.classList.toggle('on', j === k); }); }, { passive: true });
  }

  /* Gallery popup (Paul, 12 Oct, Seed reference): a click on any tile with a photo opens that photo
     alone, large, on a blurred dark version of itself; the thumbnails beneath (and the arrow keys)
     switch photos; Escape, the X or the backdrop close. */
  var lb = q('[data-rv-lb]');
  if (gal && lb) {
    /* The popup is written inside the pinned gallery column, whose position:sticky starts a stacking
       context, so there it would sit under the buy box and the header no matter its z-index. It
       moves to the end of <body>, where position:fixed covers the whole page. */
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    var zoomImgs = qa('img[data-rv-zoom]', gal), lbImg = q('[data-rv-lb-img]', lb), lbBg = q('[data-rv-lb-bg]', lb), lbThumbs = q('[data-rv-lb-thumbs]', lb), cur = 0, lastFocus = null, ths = [];
    lb.classList.toggle('rv-lb--one', zoomImgs.length < 2);
    if (lbThumbs) {
      lbThumbs.innerHTML = zoomImgs.map(function (im, i) { return '<button type="button" class="rv-lb__th" data-rv-lb-go="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy"></button>'; }).join('');
      ths = qa('.rv-lb__th', lbThumbs);
      ths.forEach(function (b) { b.addEventListener('click', function () { lbShow(+b.dataset.rvLbGo); }); });
    }
    function lbShow(i) {
      cur = (i + zoomImgs.length) % zoomImgs.length;
      var im = zoomImgs[cur];
      lbImg.src = im.dataset.rvZoom; lbImg.alt = im.alt || '';
      if (lbBg) lbBg.style.backgroundImage = 'url("' + (im.currentSrc || im.src) + '")';
      ths.forEach(function (b, j) { b.setAttribute('aria-current', String(j === cur)); });
    }
    function lbOpen(i) {
      lastFocus = document.activeElement; lbShow(i);
      lb.hidden = false; document.body.classList.add('rv-lb-open');
      var x = q('.rv-lb__x', lb); if (x) x.focus();
    }
    function lbClose() {
      lb.hidden = true; document.body.classList.remove('rv-lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    zoomImgs.forEach(function (im, i) {
      var tile = im.closest('.rv-tile') || im;
      tile.setAttribute('role', 'button'); tile.setAttribute('tabindex', '0'); tile.setAttribute('aria-label', 'Open photo ' + (i + 1));
      tile.addEventListener('click', function () { lbOpen(i); });
      tile.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbOpen(i); } });
    });
    qa('[data-rv-lb-close]', lb).forEach(function (el) { el.addEventListener('click', lbClose); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(cur - 1);
      else if (e.key === 'ArrowRight') lbShow(cur + 1);
    });
  }

  /* Timeline: rows light as they pass 68% of the window (handoff §6). */
  var tl = q('[data-rv-tline]');
  if (tl) {
    var rows = qa('.rv-trow', tl), fill = q('.rv-tfill', tl);
    function upd() {
      var vh = window.innerHeight, last = 0;
      rows.forEach(function (r, i) { var on = i === 0 || r.getBoundingClientRect().top < vh * 0.68; r.classList.toggle('on', on); if (on) last = i; });
      if (fill && rows.length) { var y = rows[last].getBoundingClientRect().top - tl.getBoundingClientRect().top + 12; fill.style.height = Math.max(0, y - 10) + 'px'; }
    }
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* Night molecules draw in when they come into view. */
  var svgs = qa('.molsvg:not(.molsvg--day)');
  if (svgs.length && !reduce && 'IntersectionObserver' in window) {
    svgs.forEach(function (sv) {
      var els = qa('line,circle,text', sv);
      function x(el) { return el.tagName === 'line' ? Math.min(+el.getAttribute('x1'), +el.getAttribute('x2')) : +(el.getAttribute('cx') || el.getAttribute('x')); }
      var xs = els.map(x), mn = Math.min.apply(null, xs), mx = Math.max.apply(null, xs), n = 0;
      els.forEach(function (el, k) { if (el.tagName === 'line') el.setAttribute('pathLength', '1'); var i = Math.round((xs[k] - mn) / ((mx - mn) || 1) * 24); n = Math.max(n, i); el.style.setProperty('--i', i); });
      sv.classList.add('anim'); sv._dur = n * 30 + 900;
    });
    var mio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var sv = e.target; mio.unobserve(sv); sv.classList.add('in'); setTimeout(function () { sv.classList.add('live'); }, sv._dur); }); }, { threshold: .35 });
    svgs.forEach(function (sv) { mio.observe(sv); });
  }

  /* Day Ones row under the buy button (Paul, 13 Oct): the clips are fetched in full as the page
     loads (preload=auto in the section), and the row previews itself once it scrolls into view
     (Paul, 13 Oct): the first clip plays its first 3 seconds, muted, then the second, then the
     third, one pass and then still. The visitor taking
     over any clip (a click on it, pressing play, unmuting) ends the cycle; the other clips go back
     to their first frame. A pause is not taken as the visitor's: browsers pause media on their own
     (a hidden tab, a phone locking), and the cycle should simply carry on when the page is back. */
  var dov = qa('[data-rv-dov]');
  if (dov.length && !reduce) {
    /* dovOn: a preview pass is running. dovUser: the visitor has taken a clip over (a tap, the speaker). */
    var dovAt = -1, dovTimer = null, dovOn = false, dovUser = false;
    /* One clip at a time (Paul, 15 Oct): taking a clip over stops whichever other clip was playing,
       the preview's or the visitor's own; a preview clip also goes back to its first frame. */
    function dovStop(keep) {
      dovUser = true;
      var pass = dovOn; dovOn = false; clearTimeout(dovTimer);
      dov.forEach(function (v) { if (v !== keep && !v.paused) { v.pause(); if (pass) v.currentTime = 0; } });
    }
    function dovStep() {
      if (!dovOn) return;
      if (dovAt >= 0) { var p = dov[dovAt]; p.pause(); p.currentTime = 0; }
      if (dovAt + 1 >= dov.length) { dovOn = false; return; } /* one pass only */
      dovAt += 1;
      var v = dov[dovAt]; v.muted = true; v._rvAuto = true;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v._rvAuto = false; });
      dovTimer = setTimeout(dovStep, 3000);
    }
    /* A fresh pass from the first clip: on first sight of the row and on every return to it (Paul, 14 Oct). */
    function dovBegin() {
      clearTimeout(dovTimer);
      /* Only a clip that has actually run is paused and rewound: touching currentTime on an unplayed
         clip makes an iPhone drop its poster and show black until it plays (Paul, 14 Oct). */
      dov.forEach(function (v) { v.muted = true; if (!v.paused) v.pause(); if (v.currentTime > 0) v.currentTime = 0; v._rvAuto = false; var f = v.closest('.rv-dovf'); if (f) f.classList.remove('is-sound'); });
      dovAt = -1; dovOn = true; dovUser = false; dovStep();
    }
    /* Out of sight: everything stops and rewinds, so the row comes back the way it started. */
    function dovRest() {
      clearTimeout(dovTimer); dovOn = false; dovUser = false;
      dov.forEach(function (v) { if (!v.paused) v.pause(); if (v.currentTime > 0) v.currentTime = 0; });
    }
    dov.forEach(function (v) {
      var frame = v.closest('.rv-dovf');
      var setSound = function () { if (frame) frame.classList.toggle('is-sound', !v.muted); var b = frame && frame.querySelector('[data-rv-dovs]'); if (b) { b.setAttribute('aria-pressed', String(!v.muted)); b.setAttribute('aria-label', v.muted ? 'Sound on' : 'Sound off'); } };
      function user() { if (v._rvAuto) { v._rvAuto = false; return; } dovStop(v); }
      v.addEventListener('play', user);
      v.addEventListener('volumechange', setSound);
      /* No native controls: a tap takes the clip over, with sound (Paul, 15 Oct). Paused: play with
         sound. Running muted (the preview): keep going, sound on. Running with sound: pause. */
      v.addEventListener('click', function () {
        dovStop(v);
        if (v.paused) { v.muted = false; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
        else if (v.muted) { v.muted = false; }
        else { v.pause(); }
      });
      /* The speaker: sound on or off for this clip; a paused clip starts playing when its sound goes on. */
      var sb = frame && frame.querySelector('[data-rv-dovs]');
      if (sb) sb.addEventListener('click', function (e) {
        e.stopPropagation();
        dovStop(v);
        v.muted = !v.muted;
        if (!v.muted && v.paused) { var p3 = v.play(); if (p3 && p3.catch) p3.catch(function () {}); }
        setSound();
      });
      if (frame) {
        v.addEventListener('play', function () { frame.classList.add('is-playing'); });
        v.addEventListener('playing', function () { frame.classList.add('has-played'); });
        v.addEventListener('pause', function () { frame.classList.remove('is-playing'); });
        v.addEventListener('ended', function () { frame.classList.remove('is-playing'); });
      }
      /* The hard stop (Paul, 13 Oct): until the visitor takes a clip over, no clip runs past its
         first 3 seconds, whatever happens to the timer (a throttled background tab, a slow decode). */
      v.addEventListener('timeupdate', function () { if (dovOn && v.currentTime > 3) { v.pause(); v.currentTime = 0; } });
    });
    document.addEventListener('visibilitychange', function () {
      if (!dovOn) return;
      clearTimeout(dovTimer);
      if (document.visibilityState === 'visible') { dovStep(); return; }
      /* hidden: the clip in play goes back to its first frame rather than running on unseen */
      if (dovAt >= 0) { dov[dovAt].pause(); dov[dovAt].currentTime = 0; }
    });
    /* The pass runs when half the row is on screen, and again each time it scrolls back in. */
    var dovRow = dov[0].closest('.rv-dorow') || dov[0];
    if ('IntersectionObserver' in window) {
      var dio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) dovBegin(); else dovRest(); }); }, { threshold: 0.5 });
      dio.observe(dovRow);
    } else { dovBegin(); }
  }

}
document.querySelectorAll('[data-kodo-rv]').forEach(init);
document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-kodo-rv]').forEach(init); });
})();
